module.exports = __webpack_public_path__ + "assets/img/logo_nav.10ffab9d.png";